import i18n from '@/i18n'
import Store from '@/store'
import ReportHeading from '@/Utils/report-head'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFontsBn from 'pdfmake/build/vfs_fonts_bn'
import pdfFontsEn from 'pdfmake/build/vfs_fonts_en'

function mobileNumber (value) {
  try {
      if (typeof value !== 'undefined' && value) {
         if (i18n.locale === 'bn') {
             return '০' + i18n.n(value, { useGrouping: false })
         } else {
          return '0' + i18n.n(value, { useGrouping: false })
      }
      }
  } catch (e) {
      return value
  }
}

function getproductName (productid) {
  let productName = ''
  const product = Store.state.ProductionService.commonObj.productList.find(item => item.value === productid)
  if (i18n.locale === 'bn') {
    productName = product.text_bn
  } else {
    productName = product.text_en
  }
  return productName
}

function getUnitName (unitid) {
  let unitName = ''
  const unit = Store.state.ProductionService.commonObj.unitInfoList.find(item => item.value === unitid)
  if (i18n.locale === 'bn') {
    unitName = unit.text_bn
  } else {
    unitName = unit.text_en
  }
  return unitName
}

function getTotal (products) {
  let totalprice = 0
  Object.entries(products).forEach(([key, value]) => {
      totalprice = totalprice + parseFloat(value.total_price)
  })
  return totalprice
}

const exportPdfDetails = async (baseUrl, uri = '/report-heading/detail', orgId, reportTitle, data, vm) => {
    try {
      Store.commit('mutateCommonProperties', {
        loading: true
      })
      if (i18n.locale === 'bn') {
        pdfMake.vfs = pdfFontsBn.pdfMake.vfs
      } else {
          pdfMake.vfs = pdfFontsEn.pdfMake.vfs
      }
      const reportHeadData = await ReportHeading.getReportHead(baseUrl, uri, orgId)
      const pdfContent = []
      for (let i = 0; i < 4; i++) {
        pdfContent.push(
          {
            table: {
              style: 'tableData',
              headerRows: 0,
              widths: ['20%', '60%', '20%'],
              body: [
                [
                  { image: reportHeadData.reportHeadColumn[0].image, height: 50, width: 50, alignment: 'center', rowSpan: 5 },
                  { text: vm.$t('production_store.govt_info'), style: 'govt_info', alignment: 'center' },
                  { image: reportHeadData.reportHeadColumn[1].image, height: 50, width: 50, alignment: 'center', rowSpan: 5 }
                ],
                [
                  {},
                  { text: reportHeadData.orgName, style: 'header2', alignment: 'center' },
                  {}
                ],
                [
                  {},
                  { text: reportHeadData.heading, style: 'address', alignment: 'center' },
                  {}
                ],
                [
                  {},
                  { text: reportHeadData.address, style: 'address', alignment: 'center' },
                  {}
                ],
                [
                  {},
                  {},
                  {}
                ]
              ]
            },
            layout: {
              hLineWidth: function (i, node) {
                return 0
              },
              vLineWidth: function (i, node) {
                return 0
              }
            }
          }
        )
        let copyName = ''
        if (i === 0) {
          copyName = vm.$t('retailerManagement.accounts_copy')
        } else if (i === 1) {
          copyName = vm.$t('retailerManagement.store_copy')
        } else if (i === 2) {
          copyName = vm.$t('retailerManagement.sales_copy')
        } else {
          copyName = vm.$t('retailerManagement.customer_copy')
        }
        pdfContent.push(
          {
            table: {
              headerRows: 0,
              widths: '33.33%',
              body: [
                [
                  {},
                  { text: reportTitle, alignment: 'center', style: 'header' },
                  { text: copyName, alignment: 'right', style: 'address2' }
                ]
              ]
            },
            layout: {
              hLineWidth: function (i, node) {
                return 0
              },
              vLineWidth: function (i, node) {
                return 0
              }
            }
          }
        )
        pdfContent.push(
          { text: vm.$t('sales_distribution_admin.bill_no') + ' : B-' + data.delivery_id, style: 'left_header', alignment: 'left', fontSize: 10 }
        )
        pdfContent.push(
          {
            table: {
              headerRows: 0,
              widths: ['50%', '50%'],
              body: [
                [
                  { text: vm.$t('retailerManagement.demand_order_no') + ' : D-' + data.demand.demmand_id, alignment: 'left', fontSize: 10 },
                  { text: vm.$t('retailerManagement.recipient') + ' : ' + (i18n.locale === 'bn' ? data.name_bn : data.name), alignment: 'right', fontSize: 10 }
                ],
                [
                  { text: vm.$t('sales_distribution_admin.delivery_date') + ' : ' + vm.$d(new Date(data.delivery_date)), alignment: 'left', fontSize: 10 },
                  { text: vm.$t('retailerManagement.contact_no') + ' : ' + mobileNumber(data.contact_no), alignment: 'right', fontSize: 10 }
                ]
              ]
            },
            layout: {
              hLineWidth: function (i, node) {
                return 0
              },
              vLineWidth: function (i, node) {
                return 0
              }
            }
          }
        )
        const allRowsHead = [
          [
            { text: vm.$t('globalTrans.sl_no'), style: 'th', alignment: 'center' },
            { text: vm.$t('production_store.pro_category'), style: 'th', alignment: 'center' },
            { text: vm.$t('production_store.pro_name'), style: 'th', alignment: 'center' },
            { text: vm.$t('sales_distribution_admin.unit'), style: 'th', alignment: 'center' },
            { text: vm.$t('sales_distribution_admin.quantity'), style: 'th', alignment: 'center' },
            { text: vm.$t('sales_distribution_admin.unit_price'), style: 'th', alignment: 'center' },
            { text: vm.$t('sales_distribution_admin.total_amount'), style: 'th', alignment: 'center' }
          ]
        ]
        data.delivery_details.map((report, index) => {
          allRowsHead.push(
          [
            { text: vm.$n(index + 1), style: 'td', alignment: 'center' },
            { text: vm.getCategoryName(report.product_id), style: 'td', alignment: 'center' },
            { text: getproductName(report.product_id), style: 'td', alignment: 'center' },
            { text: getUnitName(report.unit_id), style: 'td', alignment: 'center' },
            { text: vm.$n(report.quantity), style: 'td', alignment: 'center' },
            { text: vm.$n(report.unit_price), style: 'td', alignment: 'center' },
            { text: vm.$n(report.total_price), style: 'td', alignment: 'center' }
          ])
        })
        allRowsHead.push(
          [
            { text: vm.$t('sales_distribution_admin.total_price'), style: 'td', colSpan: 6, alignment: 'right' },
            {},
            {},
            {},
            {},
            {},
            { text: vm.$n(getTotal(data.delivery_details)), style: 'td', alignment: 'center' }
          ])
        pdfContent.push({
          table: {
            headerRows: 1,
            widths: ['6%', '*', '*', '*', '*', '*', '*'],
            body: allRowsHead
          }
        })

        const HeadEmployees = [
          [
            { },
            { }
          ],
          [
            { },
            { }
          ],
          [
            { },
            { }
          ],
          [
            { },
            { }
          ],
          [
            { },
            { }
          ],
          [
            { },
            { }
          ],
          [
            { },
            { }
          ],
          [
            { text: vm.$t('retailerManagement.soft_gen_text'), style: 'th1', alignment: 'left' },
            {}
          ],
          [
            { text: vm.currentDateTime(), style: 'th1', alignment: 'left' },
            { }
          ]
        ]
        pdfContent.push({
          table: {
            headerRows: 0,
            margin: 0,
            style: 'tableData',
            widths: ['50%', '50%'],
            body: HeadEmployees
          },
          layout: {
            hLineWidth: function (i, node) {
              return 0
            },
            vLineWidth: function (i, node) {
              return 0
            }
          }
        })
        if (i === 0 || i === 1 || i === 2) {
          pdfContent.push(
            { text: '', pageOrientation: 'portrait', pageBreak: 'after' }
          )
        }
      }
        const waterMarkText = i18n.locale === 'bn' ? 'সমাজকল্যাণ মন্ত্রণালয়' : 'Ministry of Social welfare'
        var docDefinition = {
          content: pdfContent,
          pageSize: 'A4',
          pageOrientation: 'portrait',
          watermark: { text: waterMarkText, color: 'blue', opacity: 0.1, bold: true, italics: false },
          styles: {
            th: {
              fillColor: '#dee2e6',
              border: 0,
              fontSize: 10,
              margin: [3, 3, 3, 3]
            },
            th1: {
              border: 0,
              fontSize: 10,
              margin: [3, 3, 3, 3]
            },
            td: {
              border: 1,
              fontSize: 8,
              margin: [3, 3, 3, 3]
            },
            header: {
              border: 0,
              margin: [0, 1, 0, 15],
              fontSize: 16,
              alignment: 'center'
            },
            left_header: {
              margin: [4, 0, 0, 10]
            },
            oderDetails: {
              border: true,
              fontSize: 14
            },
            govt_info: {
              margin: [0, 1, 0, 1],
              fontSize: 18,
              alignment: 'center'
            },
            address2: {
              border: 0,
              fontSize: 12,
              bold: true,
              margin: [0, 0, 0, 5]
            },
            left_logo: {
              border: 0,
              margin: [5, 0, 0, 5]
            }
          }
        }
        pdfMake.createPdf(docDefinition, null, null, null).print() // 'bill-' + data.delivery_id)
    } catch (error) {
      if (error) {}
    }
    Store.commit('mutateCommonProperties', {
      loading: false
    })
}
export default {
  exportPdfDetails
}
